export const DEFAULT_CHART_COLOR_HEX = '#FCB301';
export const CHART_COLORS_HEX = [DEFAULT_CHART_COLOR_HEX, '#4D4981'];
export const DEFAULT_CHART_COLOR_RGBA = 'rgba(252, 179, 1, 1)';
export const CHART_COLORS_RGBA = [DEFAULT_CHART_COLOR_RGBA, 'rgba(77, 73, 129, 1)'];
